import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';

import { FleetChecklistSummary } from '../../models/fleet-checklist';
import { FleetChecklistStoreService } from '../../store/fleet-checklist-store.service';
import { FleetChecklistEditorService } from '../../services/fleet-checklist-editor.service';

@Component({
  selector: 'app-fleet-checklist-edit-view',
  templateUrl: './fleet-checklist-edit-view.component.html',
  styleUrls: [
    './fleet-checklist-edit-view.component.scss',
    '../../styles/styles-component.scss',
  ]
})
export class FleetChecklistEditViewComponent implements OnInit {
  @Output() onUpdated = new EventEmitter<void>();
  submitted: boolean = false;

  constructor(
    public editor : FleetChecklistEditorService
  ) { }

  get f() {
    return this.editor.form.controls;
  }

  async ngOnInit(): Promise<void> {
  }

  async onSubmit() {
    this.submitted = true;

    if (!this.editor.isFormValid()) {
      return;
    }

    Swal.fire({
      title: 'Procesando...',
      text: 'Por favor espera mientras se guarda la información.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      let edited = await this.editor.onEdit();

      Swal.close();

      if (edited) {
        this.submitted = false;
        await Swal.fire({
          title: 'Éxito',
          text: 'Grupo de validación actualizado correctamente.',
          icon: 'success',
          confirmButtonColor: '#3b82f6',
          timer: 1500,
          timerProgressBar: true
        });

        this.editor.closeModals();
        this.onUpdated.emit();
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al editar el grupo de validación.',
          icon: 'error',
          confirmButtonColor: '#3b82f6',
        });
      }

    } catch (error) {
      Swal.close();

      Swal.fire({
        title: 'Error',
        text: 'Error inesperado durante la actualización.',
        icon: 'error',
        confirmButtonColor: '#3b82f6',
      });
    }
  }
  onCancel() {
    this.editor.closeModals();
  }
}
